import { action, computed } from "aaa";
import { CardStore } from "stores/CardStore";
import { ICardStateResponse } from "types/card";

export class ReissueCardUpgradeStore {
    cardStore = new CardStore();

    response?: ICardStateResponse;

    @computed get isLoading(): boolean {
        return this.cardStore.isLoading
            ;
    }

    @action async load(cardId: string) {
        await Promise.all([
            this.cardStore.loadCard(cardId),
        ]);
    }
}


// WEBPACK FOOTER //
// ./src/components/reissueCardUpgrade/ReissueCardUpgradeStore.tsx